import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { useVcf, VcfUploadWrapper } from "@/entities/vcf";
import { RefreshIcon } from "@/shared/icons";
import styles from "./styles.module.scss";

export const ImportVcfNoContacts = () => {
  const { t } = useTranslation();
  const {
    methods: { handleUpload },
    state: { vcfIsLoading },
  } = useVcf();

  return (
    <>
      <VcfUploadWrapper beforeUpload={handleUpload} disabled={vcfIsLoading}>
        <AppButton
          disabled={vcfIsLoading}
          className={styles["import-button"]}
          icon={<RefreshIcon className={styles.icon} />}
          iconPosition="start"
        >
          {t("contactsPage.importContacts")}
        </AppButton>
      </VcfUploadWrapper>
    </>
  );
};
